import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Row, Col, InputArea, FormField, Text, TextButton } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';

import * as css from '@src/components/global.scss';

interface Props extends InjectedTranslateProps {
  paragraphKey: string;
  maxLength: number;
  value: string;
  onChange(value: string): void;
}

export const ParagraphEditorRows = translate()(({ t, paragraphKey, maxLength, value, onChange }: Props) => {
  const onParagraphChange = (event: any) => {
    const text = event.target?.value || '';
    if (text.length <= maxLength) {
      onChange(text);
    }
  };

  const onRestoreParagraphDefault = () => onChange(t(`site:${paragraphKey}`));

  return (
    <>
      <Row className={css.rowBeforeRestoreButton}>
        <Col span={3}>
          <FormField label={t('advanced-options.categories.text.paragraph')} />
        </Col>
        <Col span={8}>
          <InputArea
            minHeight={'107px'}
            dataHook={DataHooks.AdvancedEditorsParagraph}
            key={paragraphKey}
            value={value}
            onChange={onParagraphChange}
          />
        </Col>
        <Col span={1}>
          <Text skin="disabled">{maxLength - value.length}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={3} />
        <Col span={8}>
          <TextButton size="tiny" dataHook={DataHooks.AdvancedEditorsRestore} onClick={onRestoreParagraphDefault}>
            {t('text-and-display.info-text-settings.restore-default')}
          </TextButton>
        </Col>
        <Col span={1} />
      </Row>
    </>
  );
});
